import * as ko from "knockout";
import {nsToggle} from "./nsToggle";
import {nsFa} from "../fa/fn";
import {isEnabledComputedFactory} from "../../util/misc";
import {TBaseOrObservableOrFunctionType, TBaseOrObservableType} from "../../index";
import getNextId = nsToggle.getNextId;
import ifa = nsFa.ifa;
import switchHtml from './switch.html?raw';

export let template: string = switchHtml;

export interface IParams {
    disable?: TBaseOrObservableOrFunctionType<boolean>
    enable?: TBaseOrObservableOrFunctionType<boolean>
    id?: string
    // true: toggle true == off, false == on
    // false: toggle true == on, false == off (default)
    inverse?: boolean
    label?: string
    title?: any
    toggle: KnockoutObservable<boolean>
    value: string | number
    required?: boolean
}

export class viewModel {
    private readonly checked: KnockoutComputed<boolean>;
    private readonly isEnabled: KnockoutComputed<boolean>;
    private readonly required: boolean;
    private readonly value: string | number;
    readonly id: string;
    readonly toggle: KnockoutObservable<any>;

    constructor(private params: IParams) {
        this.isEnabled = isEnabledComputedFactory(params);
        this.toggle = params.toggle;
        this.value = params.value || '';
        this.required = params.required ?? false;

        this.id = params.id ?? getNextId();
        this.checked = ko.computed({
            read: () => {
                if (this.params.inverse) {
                    return !this.toggle();
                } else {
                    return this.toggle();
                }
            },
            write: (bool: boolean) => {
                if (this.params.inverse) {
                    this.toggle(!bool);
                } else {
                    this.toggle(bool);
                }
            },
            owner: this,
        });
    }

    cls = ko.pureComputed((): string => {
        return this.checked() ? ifa('fa-check') : "";
    });

    title = ko.pureComputed((): string => {
        if ('title' in this.params) {
            return this.params.title;
        }
        if (Array.isArray(this.toggle())) {
            const bool = this.toggle().includes(this.value);
            return bool ? 'on': 'off';
        }
        return this.checked() ? 'on' : 'off';
    });

    dispose() {
        this.checked.dispose();
        this.isEnabled.dispose();
    }

}
